<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    @if (updatingBusinessInformation()) {
    <atom-loading-overlay></atom-loading-overlay>
    } @else {
    <form
        class="mx-auto h-full flex flex-col justify-start items-center overflow-y-auto w-full divide-y divide-zinc-200 dark:divide-zinc-800">
        <div class="space-y-12 w-full">
            <!-- Brand Information section -->
            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3 px-2">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Brand Information</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">A little bit about your brand and where Creators can find
                        you.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">


                    <div class="col-span-full">
                        <label for="photo" class="block text-sm/6 font-medium text-primary">Company Logo</label>
                        <div class="mt-2 flex items-center gap-x-3">
                            @if (companyLogo()) {
                            <img [src]="imageService.getImageSource(companyLogo(), 'gallery')" alt=""
                                class="size-16 shrink-0 rounded-full bg-gray-700 outline outline-1 -outline-offset-1 outline-white/10" />
                            } @else {
                            <svg viewBox="0 0 24 24" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-16 text-gray-500">
                                <path
                                    d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            }
                            <input #fileInput type="file" accept="image/*" class="hidden"
                                (change)="selectFile($event)" />
                            <button type="button" (click)="fileInput.click()"
                                class="text-primary secondary-button">Change</button>
                        </div>
                    </div>

                    <div class="col-span-full">
                        <label for="cover-photo-upload"
                            class="block text-sm/6 font-medium text-primary">Cover photo</label>
                        <input #coverFileInput id="cover-photo-upload" type="file" name="cover-photo-upload"
                            accept="image/png,image/jpeg,image/gif" class="sr-only"
                            [disabled]="coverPhotoLoading()" (change)="selectCoverFile($event)" />
                        @if (businessInformationModel().coverPhoto && !coverPhotoBroken()) {
                        <div class="relative mt-2 aspect-video w-96 max-w-full overflow-hidden rounded-lg border border-zinc-200 bg-zinc-100 dark:border-zinc-700 dark:bg-zinc-900"
                            [class]="coverDragging() ? 'ring-2 ring-primary' : ''"
                            (dragover)="onCoverDragOver($event)" (dragleave)="onCoverDragLeave($event)"
                            (drop)="onCoverDrop($event)">
                            <img [src]="imageService.getImageSource(businessInformationModel().coverPhoto, 'gallery_16_9')"
                                alt="Brand cover photo" class="h-full w-full object-cover"
                                (error)="onCoverPhotoError()" />
                            @if (coverPhotoLoading()) {
                            <div class="absolute inset-0 flex items-center justify-center bg-black/40">
                                <p class="m-0 text-sm font-medium text-white">Uploading cover photo…</p>
                            </div>
                            }
                            <div class="absolute right-3 top-3 z-10">
                                <button type="button" (click)="coverFileInput.click()" [disabled]="coverPhotoLoading()"
                                    class="btn-shout btn-shout-sm btn-shout-secondary">Change</button>
                            </div>
                        </div>
                        } @else {
                        <div class="mt-2 flex justify-center rounded-lg border border-dashed px-6 py-10"
                            [class]="coverDragging() ? 'border-primary bg-primary/5' : 'border-gray-900/25 dark:border-white/25'"
                            (dragover)="onCoverDragOver($event)" (dragleave)="onCoverDragLeave($event)"
                            (drop)="onCoverDrop($event)">
                            <div class="text-center">
                                <svg viewBox="0 0 24 24" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="mx-auto size-12 text-gray-300 dark:text-gray-600">
                                    <path
                                        d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                                @if (businessInformationModel().coverPhoto) {
                                <p class="m-0 mt-4 text-sm text-gray-600 dark:text-gray-400">The current cover photo
                                    could not be displayed. Upload a new file to replace it.</p>
                                }
                                <div class="mt-4 flex flex-col items-center gap-2">
                                    <button type="button" (click)="coverFileInput.click()"
                                        [disabled]="coverPhotoLoading()"
                                        class="btn-shout btn-shout-sm btn-shout-secondary">
                                        {{ coverPhotoLoading() ? 'Uploading…' : 'Upload a file' }}
                                    </button>
                                    <p class="m-0 text-sm text-gray-600 dark:text-gray-400">or drag and drop</p>
                                </div>
                                <p class="mt-2 text-xs/5 text-gray-600 dark:text-gray-400">PNG, JPG, GIF up to 10MB</p>
                            </div>
                        </div>
                        }
                        @if (coverPhotoError()) {
                        <p class="mt-2 text-sm text-red-600 dark:text-red-400" role="alert">{{ coverPhotoError() }}</p>
                        }
                    </div>

                    <div class="sm:col-span-3">
                        <label for="first-name" class="block text-sm/6 font-medium text-primary">Company name</label>
                        <div class="mt-2">
                            <input [formField]="businessInformationForm.companyName" id="first-name" type="text"
                                autocomplete="given-name" class="input-primary text-primary" />
                        </div>
                    </div>
                    <div class="sm:col-span-3">
                        <label for="last-name" class="block text-sm/6 font-medium text-primary">Website</label>
                        <div class="mt-2 flex">
                            <div
                                class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                                https://</div>
                            <input [formField]="businessInformationForm.website" id="company-website" type="text"
                                placeholder="www.example.com" class="input-url text-primary" autocomplete="website" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">About</label>
                        <div class="mt-2">
                            <textarea [formField]="businessInformationForm.about" id="comment" rows="3"
                                class="input-textarea text-primary"></textarea>
                        </div>
                        <p class="mt-1 text-xs leading-6 text-gray-600">Write a few sentences
                            about your company.</p>
                    </div>

                    <div class="sm:col-span-3">
                        <label for="first-name" class="block text-sm/6 font-medium text-primary">Instagram</label>
                        <div class="mt-2 grid grid-cols-1">
                            <input [formField]="businessInformationForm.instagram" id="email" type="email"
                                placeholder="instagram handle" class="input-icon text-primary" />
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                                <circle cx="12" cy="12" r="4" />
                                <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
                            </svg>
                        </div>
                    </div>
                    <div class="sm:col-span-3">
                        <label for="last-name" class="block text-sm/6 font-medium text-primary">TikTok</label>
                        <div class="mt-2 grid grid-cols-1">
                            <input [formField]="businessInformationForm.tiktok" id="email" type="email"
                                placeholder="tiktok handle" class="input-icon text-primary" />
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                                <circle cx="12" cy="12" r="4" />
                                <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
                            </svg>
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <label for="operating-currency" class="block text-sm/6 font-medium text-primary">Operating
                            Currency</label>
                        <div class="mt-2 grid grid-cols-1">
                            <div id="operating-currency" class="input-icon text-primary cursor-default"
                                aria-label="Operating Currency">
                                {{ selectedCurrencyLabel() }}
                            </div>
                            <span
                                class="pointer-events-none col-start-1 row-start-1 ml-3 self-center text-base font-semibold text-gray-500 sm:text-sm/6"
                                aria-hidden="true">{{ selectedCurrencySymbol() }}</span>
                        </div>
                        <p class="mt-1 text-xs leading-6 text-secondary">Contact SHOUT to change currency.</p>
                    </div>



                </div>
            </div>
            <!-- Brand Information section END -->
        </div>
        <div class="mt-6 flex items-center justify-end gap-x-6 w-full">
            <button type="button" (click)="saveChanges()" class="primary-button">Save</button>
        </div>
    </form>
    }
</div>